export type StepName = "number" | "operator" | "order" | "recipient"| "summary" | "payment";
const FiveStepMap = new Map<StepName, number>(
    [
        ["number", 1],
        ["operator", 2],
        ["order", 3],
        ["recipient", 3.1],
        ["summary", 4],
        ["payment", 5],
    ]
);
const FourStepMap = new Map<StepName, number>(
    [
        ["number", 1],
        ["order", 2],
        ["summary", 3],
        ["payment", 4],
    ]
);
const ThreeStepMap = new Map<StepName, number>(
    [
        ["order", 1],
        ["recipient", 1.1],
        ["summary", 2],
        ["payment", 3],
    ]
);
// function toStepName(stepNumber: number) : StepName {
//     if (FiveStepMap.get("number") === stepNumber) return "number";
//     if (FiveStepMap.get("operator") === stepNumber) return "operator";
//     if (FiveStepMap.get("order") === stepNumber) return "order";
//     if (FiveStepMap.get("summary") === stepNumber) return "summary";
//     if (FiveStepMap.get("payment") === stepNumber) return "payment";
//     throw new Error("Invalid StepNumber");
// }
function toNumber(hasOperator: boolean, stepName: StepName, isGiftCard: boolean) {
    return  isGiftCard ? ThreeStepMap.get(stepName)! : hasOperator ? FiveStepMap.get(stepName)! : FourStepMap.get(stepName)!;
}
export class Step {
    private _hasOperator: boolean;
    private _stepName: StepName = "number";
    private _isGiftCard: boolean;
    constructor(hasOperator: boolean, isGiftCard?: boolean) {
        this._hasOperator = hasOperator;
        this._isGiftCard = isGiftCard || false;
    }
    get stepCount() {
        return this._isGiftCard ? 3 : this._hasOperator ? 5 : 4;
    }
    get current() {
        return this._stepName;
    }
    // get currentNum() {
    //     return toNumber(this._hasOperator, this._stepName);
    // }
    toNum(stepName: StepName) {
        return toNumber(this._hasOperator, stepName, this._isGiftCard)
    }
    set(stepNum: StepName) {
        this._stepName = stepNum;
        if (!this._hasOperator && stepNum === "operator") this._stepName = "order";
        return this.clone();
    }
    compareTo(stepName: StepName | Step): ">" | "=" | "<" {
        if (stepName instanceof Step) {
            return this.compareTo(stepName.current);
        } else {
            const thisNumber = toNumber(this._hasOperator, this._stepName, this._isGiftCard);
            const otherNumber = toNumber(this._hasOperator, stepName, this._isGiftCard);
            if (thisNumber > otherNumber) return ">";
            if (thisNumber < otherNumber) return "<";
            return "=";
        }
    }
    parse(name: string | undefined) {
        if(this._isGiftCard){
            if (ThreeStepMap.has(name as StepName)) return name as StepName;
            else return undefined;
        }
        else if (this._hasOperator) {
            if (FiveStepMap.has(name as StepName)) return name as StepName;
            else return undefined;
        } else {
            if (FourStepMap.has(name as StepName)) return name as StepName;
            else return undefined;
        }
    }
    // // /**
    // //  * Here you pass the step number as if there are 5 steps.
    // //  */
    // setByNum(stepNumber: number) {
    //     let stepName = toStepName(stepNumber);
    //     if (!this._hasOperator && stepName === "operator") stepName = "order";
    //     this._stepName = stepName;
    //     return this.clone();
    // }
    // max(value: StepName) {
    //     const thisNumber = toNumber(this._hasOperator, this._stepName);
    //     const valueNumber = toNumber(this._hasOperator, value);
    //     if (thisNumber >= valueNumber) return this;
    //     const newStep = this.clone();
    //     newStep.set(value);
    //     return newStep;
    // }
    private clone() {
        const newStep = new Step(this._hasOperator, this._isGiftCard);
        newStep._stepName = this._stepName;
        newStep._isGiftCard = this._isGiftCard;
        return newStep;
    }
}